<template>
  <div class="w-100 h-100 m-0" style="padding: 32px; background: #FFFFFF;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">発行コード詳細</div>
      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnList()" >
          チケット一覧
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnEventEdit()" >
          チケット詳細
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnIssueList()" >
          発行コード履歴
        </div>
        <div>＞</div>
        <div>発行コード詳細</div>
      </div>

      <div class="m-0 acrypro-text-main-bold text-start d-flex justify-content-between" style="height: 56px; border-bottom: solid 1px #8C9BC6; padding: 8px 0px;">
        <div>発行コード</div>
        <button class="m-0 acry-btn fw-bold" style="width: 212px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickCSV">
            コードダウンロード
        </button>
      </div>

      <div class="w-100 m-0 p-0">
        <div class="w-100 d-flex align-items-center text-start table-header" style="font-size: 13px; gap: 24px;">
          <div style="width: 160px;">コード</div>
          <div style="width: 160px;">有効期限</div>
          <div style="width: 160px;">使用状況</div>
          <div style="width: 160px;">使用日</div>
        </div>
        <div v-for="(data, key) in codeData" :key="key" class="w-100 code-cell d-flex text-start" style="height: 72px; font-size: 15px;" :style="getBgColor(data.isUsed, data.validTo)">
          <div class="my-auto" style="width: 184px;">{{data.docId}}</div>
          <div class="my-auto d-flex flex-column" style="width: 184px;">
            <div>{{formatDate(data.validFrom.toDate())}}〜</div>
            <div>{{formatDate(data.validTo.toDate())}}</div>
          </div>
          <div v-if="data.isUsed" class="my-auto" style="width: 184px;">使用済み</div>
          <div v-if="!data.isUsed" class="my-auto" style="width: 184px; color: #BC6665;">未使用</div>
          <div v-if="data.isUsed" class="my-auto" style="width: 184px;">{{formatDate(data.usedAt.toDate())}}</div>

          <div class="flex-grow-1"></div>
          <div class="m-auto" style="width: 212px;">
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { CSV } from "@/js/CSV.js";
import { CenterViewState } from "@/js/Const.js";

export default {
  name: "CenterViewEventTicketIssueDetail_Ap",
  props: {},
  data: function () {
    return {
      codeData:[],

    };
  },
  computed: {

  },
  async created() {
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    console.log(this.$store.state.acrylicTicketCouponManager.selectTicketIssueData);

    this.codeData = await this.$store.state.acrylicTicketCouponManager.getAcryCouponCode(
      this.$store.state.acrylicTicketCouponManager.selectTicketIssueData.acryCouponCodeIssuedHistory).catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    console.log(this.codeData);

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },
    onClickReturnList(){
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },
    onClickReturnEventEdit(){
      this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
    },
    onClickReturnIssueList(){
      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueHistory);
    },
    getBgColor(isUsed, toDate){
      if( !isUsed && toDate.toDate() > (new Date()) ){
        return {"background": "#FFFFFF"};
      }else{
        return {"background": "#F8F8F8"};
      }
    },
    async onClickAllCSV(){

    },

    async onClickCSV(){
      const csv = new CSV();
      csv.useHeader = true;
      csv.header = ['コード', '開始日', '終了日', '使用日'];
      let csvData = [];

      for( const code of this.codeData ){
        csvData.push([code.docId, this.formatDate(code.validFrom.toDate()), this.formatDate(code.validTo.toDate()), code.usedAt?this.formatDate(code.usedAt.toDate()):""]);
      }
      csv.data = csvData;
      csv.exportData();
    },

    async onClickReceipt(){

    },

    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.table-header{
  width: 800px;
  height: 30px;
  padding: 0px 16px;
  gap: 24px;
  background: #F8F8F8;
  border-bottom: solid 1px #D1D5DB;
}
.code-cell{
  width: 800px;
  height: 120px;
  padding: 16px;
  border-bottom: solid 1px $border-sub-color;
}
</style>


